export const routeConfig = {
  meta: {
    title: '数据融资',
  }
};
